import media from '../media/media.js';
import verge from 'verge';
window.jQuery = $;
require('@fancyapps/fancybox');

const mediaAlbumTemplate = require('./media-album.ejs');
const mediaAlbumContainer = document.querySelector('.media-album');
const exists = typeof(mediaAlbumContainer) != 'undefined' && mediaAlbumContainer != null;

document.addEventListener('DOMContentLoaded', () => {
    if (exists) {
        let mediaAlbums = new mediaAlbum(mediaAlbumContainer, mediaAlbumTemplate).init();
    };
});


class mediaAlbum extends media {

    constructor(container, template) {
        super(container, template);
        this.thumbsVisible = false;
        this.enableCreating = true;
        this.code = container.getAttribute('data-param-code');
    }

    init() {
        super.getData(true);
        super.appendBackBtn();
        this.initFancybox();
        this.initEvents();
    }

    initEvents() {
        /* Open modal on click btn full */
        $(document).on('click', '.js-media-album-option-full', function(e) {
            e.preventDefault();
            $(this)
                .closest('.media-album__item')
                .find('[data-fancybox="album"]')
                .trigger('click');
        })
    }

    initFancybox() {
        $('[data-fancybox="album"]').fancybox({
            thumbs: {
                axis: 'x',
                autoStart: true,
                hideOnClose: false
            },
            hash: false,
            touch: true,
            infobar: false,
            smallBtn: true,
            clickOutside: 'close',
            mobile: {
                idleTime: false,
                clickSlide: 'close',
                clickContent: 'toggleControls'
            },
            selector: '.media-album__option--call',
            spinnerTpl: '<div class="preloader"></div>',
            baseClass: 'fancybox-container--media-album',
            btnTpl: {
                arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"></button>',
                arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"></button>'
            },
            baseTpl: `
                <div class="fancybox-container" role="dialog" tabindex="-1">
                    <div class="fancybox-bg"></div>
                    <div class="fancybox-inner">
                        <div class="fancybox-navigation">{{arrows}}</div>
                        <div class="fancybox-caption"></div>
                        <div class="fancybox-stage"></div>
                    </div>
                    <div class="fancybox-thumbs-wrapper hidden"></div>
                </div>`,
            beforeShow: instance => {
                let id = $('[data-fancybox="album"]').eq(instance.currIndex).attr('id');
                if (id) {
                    window.location.hash = id;
                }

                if (instance.Thumbs.$grid) {
                    this.composeThumbs(instance.Thumbs.$grid[0]);
                }
            },
            afterShow: instance => {
                this.createCaption(instance);
                const btn = this.createDownloadBtn(instance);
                this.changeDownloadBtnPosition();
                this.enableCreating = false;
            },
            beforeClose: () => {
                this.hideThumbs();
                window.location.hash = '';
            },
            afterClose: () => {
                this.thumbsVisible = false;
                this.enableCreating = true;
            }
        });
    }

    composeThumbs(thumbs) {
        if (this.enableCreating) this.createThumbsToggleBtn(this.wrapThumbs(thumbs));
    }

    wrapThumbs(thumbs) {
        let thumbsWrapper = document.querySelector('.fancybox-thumbs-wrapper');
        thumbsWrapper.appendChild(thumbs);
        return thumbsWrapper;
    }

    createThumbsToggleBtn(thumbs) {
        let toggleBtn = document.createElement('div');

        toggleBtn.className = 'media-album__toggle';
        thumbs.appendChild(toggleBtn).addEventListener('click', () => {
            thumbs.classList.toggle('hidden');
            this.thumbsVisible = !this.thumbsVisible;
            this.changeDownloadBtnPosition();
        });
    }

    changeDownloadBtnPosition() {
        let current = document.querySelector('.fancybox-slide--current'),
            button = current.querySelector('.media-album__option'),
            thumbs = document.querySelector('.fancybox-thumbs-wrapper'),
            onTheEdge = !verge.inY(button, -300);

        button.classList.remove('pushed');

        if (onTheEdge && this.thumbsVisible) button.classList.add('pushed');
    }

    hideThumbs() {
        let thumbsWrapper = document.querySelector('.fancybox-thumbs-wrapper');
        thumbsWrapper.classList.add('hidding');
    }

    createCaption(instance) {
        let content = instance.current.$content[0];

        if (content.querySelector('.media-album__title') != null) return;

        let caption = document.createElement('div');
        caption.className = 'media-album__title';
        caption.innerHTML = instance.current.opts.caption;
        content.appendChild(caption);
    }

    createDownloadBtn(instance) {
        let orig = instance.current.opts.$orig[0],
            content = instance.current.$content[0];

        if (content.querySelector('.media-album__option') != null) return;

        let size = document.createElement('span'),
            format = document.createElement('span'),
            download = document.createElement('a'),
            src = !('download' in document.createElement('a')) ? `${instance.current.src}?download=true` : instance.current.src;

        if (!('download' in document.createElement('a'))) {
            download.setAttribute('target', '_blank');
        }

        download.setAttribute('href', src);
        download.setAttribute("download", '');
        download.className = 'media-album__option media-album__option--download';
        format.innerHTML = orig.getAttribute('data-fileformat');
        size.innerHTML = orig.getAttribute('data-filesize');

        download.appendChild(format);
        download.appendChild(size);
        content.appendChild(download);

        return download;
    }
}


// WEBPACK FOOTER //
// ./frontend/components/media-album/media-album.js